module.exports = __webpack_public_path__ + "static/media/3_Company Lobby - Tokyo.48ec3d62.jpg";